/* AcademyHero — the exact Academy page opening: gold letter-spaced eyebrow,
   large Bodoni heading with the last word in bronze italics, one lede line. */
const emTitle = (t) => {
  const m = String(t || '').match(/^(.*?)(\S+)$/);
  if (!m) return <>{t}</>;
  return (<>{m[1]}<em>{m[2]}</em></>);
};

export const AcademyHero = ({ eyebrow, title, lede, onPlum = false, testId = 'academy-hero' }) => (
  <div className={`achero${onPlum ? ' on-plum' : ''}`} data-testid={testId}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h1>{emTitle(title)}</h1>
    {lede && <p className="lede">{lede}</p>}
  </div>
);
